import React, { useEffect } from "react";

const NurseryClassChild = ({ statList, height = 300 }) => {
    useEffect(() => {
        return () => {};
    }, [statList]);
    if (!statList) {
        return (
            <div className="w-100">
                <div className="row">
                    <div
                        className="col"
                        style={{
                            height: "220px",
                            textAlign: "center",
                            paddingTop: `50px`,
                        }}
                    >
                        <span className="dashboard-spinner spinner-xl"></span>
                    </div>
                </div>
            </div>
        );
    } else {
        var totalClass = statList.length;
        var totalChildContract = statList.reduce((ac, current) => ac + (current.childContract ? current.childContract : 0), 0);
        var totalChildRegist = statList.reduce((ac, current) => ac + (current.childRegist ? current.childRegist : 0), 0);

        const rateJoin = totalChildContract ? ((totalChildRegist / totalChildContract) * 100).toFixed() : 0;
        const heightValue = totalClass > 6 ? height + "px" : "100%";

        return (
            <div className="w-100">
                <table className="table table-sm table-striped text-center">
                    <thead style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
                        <tr className="" style={{ backgroundColor: "#b9c7dc" }}>
                            <th scope="col">반</th>
                            <th scope="col">계약 원아 수</th>
                            <th scope="col">등록 원아 수</th>
                        </tr>
                    </thead>
                    <tbody style={{ overflowY: "auto", display: "block", height: heightValue }}>
                        {statList.map((s, idx) => (
                            <tr key={`class-child-${idx}`} id={`class-child-${s.id}`} style={{ display: "table", tableLayout: "fixed", width: "100%" }}>
                                <td className="" style={{ backgroundColor: "#c8e6ef" }}>
                                    {s.className}
                                </td>
                                <td>{(s.childContract ? s.childContract : 0).toLocaleString()}</td>
                                <td>{(s.childRegist ? s.childRegist : 0).toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="" style={{ color: "#ffffff", display: "table", tableLayout: "fixed", width: "100%", backgroundColor: "#7EC9EB" }}>
                            <td>합계</td>
                            <td>{totalChildContract.toLocaleString()}</td>
                            <td>{totalChildRegist.toLocaleString()}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
};

export { NurseryClassChild };
